import { usePageContext } from "vike-react/usePageContext";

import { type Locale,LOCALES } from "@/0-app/providers/I18nProvider";

export default function LanguageSelector({ onSelect }: { onSelect?: () => void }) {
  const pc = usePageContext();
  const current: Locale = pc.locale ?? "it";
  const logical: string = pc.urlLogical ?? pc.urlPathname ?? "/";

  return (
    <div className="flex items-center gap-0.5 text-sm">
      {LOCALES.map((lng) => (
        <a
          key={lng}
          href={`/${lng}${logical === "/" ? "" : logical}`}
          onClick={() => onSelect?.()}
          aria-current={lng === current ? "true" : undefined}
          className={`px-1.5 py-0.5 rounded transition-colors ${
            lng === current
              ? "font-semibold text-dec-green"
              : "text-zinc-400 hover:text-zinc-700"
          }`}
        >
          {lng.toUpperCase()}
        </a>
      ))}
    </div>
  );
}
